/* */ 
"use strict";
var lang_1 = require('./facade/lang');
var collection_1 = require('./facade/collection');
exports.MODULE_SUFFIX = lang_1.IS_DART ? '.dart' : '';
var CAMEL_CASE_REGEXP = /([A-Z])/g;
var DASH_CASE_REGEXP = /-([a-z])/g;
function camelCaseToDashCase(input) {
  return lang_1.StringWrapper.replaceAllMapped(input, CAMEL_CASE_REGEXP, function(m) {
    return '-' + m[1].toLowerCase();
  });
}
exports.camelCaseToDashCase = camelCaseToDashCase;
function dashCaseToCamelCase(input) {
  return lang_1.StringWrapper.replaceAllMapped(input, DASH_CASE_REGEXP, function(m) {
    return m[1].toUpperCase();
  });
}
exports.dashCaseToCamelCase = dashCaseToCamelCase;
function splitAtColon(input, defaultValues) {
  var parts = lang_1.StringWrapper.split(input.trim(), /\s*:\s*/g);
  if (parts.length > 1) {
    return parts;
  } else {
    return defaultValues;
  }
}
exports.splitAtColon = splitAtColon;
function sanitizeIdentifier(name) {
  return lang_1.StringWrapper.replaceAll(name, /\W/g, '_');
}
exports.sanitizeIdentifier = sanitizeIdentifier;
function visitValue(value, visitor, context) {
  if (lang_1.isArray(value)) {
    return visitor.visitArray(value, context);
  } else if (lang_1.isStrictStringMap(value)) {
    return visitor.visitStringMap(value, context);
  } else if (lang_1.isBlank(value) || lang_1.isPrimitive(value)) {
    return visitor.visitPrimitive(value, context);
  } else {
    return visitor.visitOther(value, context);
  }
}
exports.visitValue = visitValue;
var ValueTransformer = (function() {
  function ValueTransformer() {}
  ValueTransformer.prototype.visitArray = function(arr, context) {
    var _this = this;
    return arr.map(function(value) {
      return visitValue(value, _this, context);
    });
  };
  ValueTransformer.prototype.visitStringMap = function(map, context) {
    var _this = this;
    var result = {};
    collection_1.StringMapWrapper.forEach(map, function(value, key) {
      result[key] = visitValue(value, _this, context);
    });
    return result;
  };
  ValueTransformer.prototype.visitPrimitive = function(value, context) {
    return value;
  };
  ValueTransformer.prototype.visitOther = function(value, context) {
    return value;
  };
  return ValueTransformer;
}());
exports.ValueTransformer = ValueTransformer;
function assetUrl(pkg, path, type) {
  if (path === void 0) {
    path = null;
  }
  if (type === void 0) {
    type = 'src';
  }
  if (lang_1.IS_DART) {
    if (path == null) {
      return "asset:angular2/" + pkg + "/" + pkg + ".dart";
    } else {
      return "asset:angular2/lib/" + pkg + "/src/" + path + ".dart";
    }
  } else {
    if (path == null) {
      return "asset:@angular/lib/" + pkg + "/index";
    } else {
      return "asset:@angular/lib/" + pkg + "/src/" + path;
    }
  }
}
exports.assetUrl = assetUrl;
